import React, { useEffect, useState } from 'react'
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import GridPrincipal from '../../components/GridPrincipal'
import { AxiosResponse } from "axios";
import api from "../../Services/api";
import secureLocalStorage from "react-secure-storage";
import ModalPrincipal from '../../components/ModalAlert/modal'
import { useNavigate } from 'react-router';
import Loading from '../../components/Loading';


function Panel() {

  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false)
  const [qualAlert, setQualAlert] = useState(<></>)
  const [exibirGrid, setExibirGrid] = useState(<></>);

  useEffect(() => {


    validatToken()



  }, []);


  async function validatToken() {

    let ret: AxiosResponse;
    let valor: any;

    const _user = secureLocalStorage.getItem('t')


    api.defaults.headers.common['Authorization'] = _user as ''

    try {

      ret = await api.get("/status/validar")

      if (ret.data.status === 200) {

        setExibirGrid(<GridPrincipal
          iconeExcluir={ModalDeletar}
          th1='Ativo'
          th2='ID'
          th3='Descrição'
          th4='Ambiente'
          th5='Data da Inclusão'
          th6='Data Atualização'
          endPoint='panel/listar'
          consult='N'
          col1='1'
          col2='0'
          col3='2'
          col4='9'
          col5='6'
          col6='8'
          ambiente=''
          fromAdd='/panel/add'
          fromEdit={`/panel/edit`}
          btnDelete='N'
        />)

      }

    } catch (e: any) {

      if (e.response.data.status === 403) {

        setQualAlert(<div className='div-alert'>
          <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Token inválido ou expirado!</span></div>
          <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
        </div>)

        setOpenModal(true)

      }
    }

  }


  function ModalDeletar() {

  }

  function fecharModal() {

    secureLocalStorage.removeItem('t')
    navigate('/login');
    setOpenModal(false)

  }

  return (
    <>
      <Nav />
      <div className="main-content">
        <Header />
        <main>
          <div className='containerPrincipal'>
            <div className='div-titulo-pages'>
              <span className='fa fa-th-list' />
              <h1 className='div-titulo-pages-text'>Painel</h1>
            </div>
            {exibirGrid}
          </div>
        </main>
      </div>

      <ModalPrincipal isOpen={openModal} setModalOpen={() => setOpenModal(!openModal)}>
        <div className='container-modal-alert'>
          {qualAlert}
        </div>
      </ModalPrincipal>
    </>
  );

}

export default Panel;